import {
    PDFViewer,
    Document,
    StyleSheet,
    Page,
    View,
    Text,
    Font
  } from '@react-pdf/renderer'
  import React, { useEffect, useState } from 'react'
  //@ts-ignore
  import font from '../../../assets/fonts/OpenSauceSans-Bold.ttf'
  //@ts-ignore
  import fontRegular from '../../../assets/fonts/OpenSauceSans-Regular.ttf'
  import PdfView from '../../../components/Display/PdfView'
  import { formatPipe } from '../../../utils/utils'
  import {DateTime} from 'luxon'
  
  
  
 const Analytical : React.FC<IAnalytical> = ({data, dateFrom, dateTo, businessSocial, businessDocument, parentCode, parentName, parentBalance, parentBeforeBalance, accountName, accountCode}) => {
    
      Font.register({
          family: 'Open Sans',
          fonts: [{ src: font }],
        })
  
      Font.register({
          family: 'Open Sans-normal',
          fonts: [{ src: fontRegular }],
      })
  
    const styles = StyleSheet.create({
      headerContainer: {
        textAlign: 'center',
      },
      flexColContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
        marginTop: 30,
      },
    })
  
  //   const [data, setData] = useState<any[]>([
  //     {
  //       date: '21/01/2023',
  //       amount: 2147,
  //       description: 'Pago de nómina empleados',
  //       type: 'HABER',
  //       code: 125257,
  //       account: 'Fecha nómina empleados',
  //     },
  //     {
  //       date: '21/01/2023',
  //       amount: 2147,
  //       description: 'Pago de nómina empleados',
  //       type: 'HABER',
  //       code: 125257,
  //       account: 'Fecha nómina empleados',
  //     },
  //     {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       }, {
  //         date: '21/01/2023',
  //         amount: 2147,
  //         description: 'Pago de nómina empleados',
  //         type: 'HABER',
  //         code: 125257,
  //         account: 'Fecha nómina empleados',
  //       },
  //   ])
  
    return (
        <Document title={`mayor-analitico`}>
          <Page size="LETTER" style={{ padding: 30 }}>
            <View style={styles.headerContainer}>
              <Text style={{ marginBottom: 10, fontFamily: 'Open Sans', fontSize: 15 }}>
                Mayor Analítico
              </Text>
              <Text style={{ fontSize: 10, marginBottom: 10, fontFamily: 'Open Sans-normal' }}>
                {accountName}
              </Text>
              <Text style={{ marginBottom: 10, fontFamily: 'Open Sans-normal', fontSize: 15 }}>{businessSocial}</Text>
              <Text style={{ fontSize: 10, marginBottom: 10, fontFamily: 'Open Sans-normal' }}>
                {businessDocument}
              </Text>
              <Text style={{ fontSize: 10, fontFamily: 'Open Sans-normal' }}>{dateFrom} hasta {dateTo}</Text>
            </View>

            <View style={{marginTop: 20, width: '100%'}}>
                <View style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between'}}>
                    <View style={{width: '15%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans'}}>Cód.</Text>
                    </View>
                    <View style={{width: '30%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans'}}>Nombre de la cuenta</Text>
                    </View>

                    <View style={{width: '20%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans'}}>Saldo Anterior</Text>
                    </View>

                    <View style={{width: '20%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans'}}>Saldo Final</Text>
                    </View>

                </View>

                <View style={{display: 'flex', flexDirection: 'row', marginTop: 10, width: '100%', justifyContent: 'space-between'}}>
                    <View style={{width: '15%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal', overflow: 'hidden', textOverflow: 'ellipsis'}}>{parentCode}</Text>
                    </View>
                    <View style={{width: '30%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentName}</Text>
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBeforeBalance}</Text> */}
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBalance}</Text> */}
                    </View>
                </View>

                <View style={{display: 'flex', flexDirection: 'row', marginTop: 15, width: '100%', justifyContent: 'space-between'}}>
                    <View style={{width: '15%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal', overflow: 'hidden', textOverflow: 'ellipsis'}}>{accountCode}</Text>
                    </View>
                    <View style={{width: '30%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{accountName}</Text>
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBeforeBalance}</Text> */}
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBalance}</Text> */}
                    </View>
                </View>

                <View style={{display: 'flex', flexDirection: 'row', marginTop: 15, width: '100%', justifyContent: 'space-between'}}>
                    <View style={{width: '15%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal', overflow: 'hidden', textOverflow: 'ellipsis'}}>{accountCode}</Text> */}
                    </View>
                    <View style={{width: '30%', textAlign: 'center'}}>
                        {/* <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{accountCode}</Text> */}
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBeforeBalance}</Text>
                    </View>
                    <View style={{width: '20%', textAlign: 'center'}}>
                        <Text style={{fontSize: 10, fontFamily: 'Open Sans-normal'}}>{parentBalance}</Text>
                    </View>
                </View>

            </View>

            <View style={{height: 2, width: '100%', backgroundColor: "#2A5BC3", marginTop: 20}}></View>
  
            <View style={styles.flexColContainer}>
              <View style={{ flexBasis: '15%' }}>
                <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Fecha</Text>
              </View>

              <View style={{ flexBasis: '30%' }}>
                <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Tipo</Text>
              </View>
      
              <View style={{ flexBasis: '20%' }}>
                <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>
                  Descripción
                </Text>
              </View>
  
              <View style={{ flexBasis: '20%' }}>
                <Text style={{ textAlign: 'center', fontSize: 10, fontFamily: 'Open Sans' }}>Monto</Text>
              </View>

            </View>
  
            {data &&
              data.map((row, index) => (
                  <View style={{ ...styles.flexColContainer, paddingHorizontal: 10, paddingVertical: 5, borderRadius: 8, marginTop: 10, backgroundColor: index % 2 === 0 ? '#e7eaf6' : 'white' }}>
                  <View style={{ flexBasis: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ textAlign: 'center', fontSize: 10 }}>
                      {DateTime.fromISO(row?.date).toFormat("dd/MM/yyyy")}
                    </Text>
                  </View>

                  <View style={{ flexBasis: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ textAlign: 'center', fontSize: 10 }}>
                      {row?.type}
                    </Text>
                  </View>
  
                  <View style={{ flexBasis: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ textAlign: 'center', fontSize: 10 }}>
                      {row?.description}
                    </Text>
                  </View>

                  <View style={{ flexBasis: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Text style={{ textAlign: 'center', fontSize: 10 }}>
                      {formatPipe(row?.amount)}
                    </Text>
                  </View>

                </View>
              ))}
          </Page>
        </Document>
    )
  }
  
  export interface IAnalytical {
      data: any[]
      dateFrom: string
      dateTo: string
      businessSocial: string
      businessDocument: string
      parentCode: string 
      parentName: string
      parentBalance: string
      parentBeforeBalance: string
      accountName: string
      accountCode: string
  }
  
  export default Analytical
  